import { render, staticRenderFns } from "./sub-footer.vue?vue&type=template&id=16aba249&scoped=true&"
import script from "./sub-footer.vue?vue&type=script&lang=js&"
export * from "./sub-footer.vue?vue&type=script&lang=js&"
import style0 from "./sub-footer.vue?vue&type=style&index=0&id=16aba249&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aba249",
  null
  
)

export default component.exports